import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";

export const useInstalledCapicity = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data = [], isLoading } = useGetProtectedApiDataQuery({
    url: "energy-assets",
    lang: languageType,
  });

  const processed = useMemo(() => {
    const filterByType = (type) =>
      data.filter(
        (item) =>
          item.field_category_page_assets === type &&
          item.field_status === "Completed",
      );

    const sum = (arr) =>
      arr.reduce((acc, item) => {
        const val = parseFloat(item?.field_plant_size);
        return acc + (isNaN(val) ? 0 : val);
      }, 0);

    const hydro = filterByType("Hydro Power");
    const thermal = filterByType("Thermal Power");
    const solar = filterByType("Solar Power");

    const hydroTotal = sum(hydro);
    const thermalTotal = sum(thermal);
    const solarTotal = sum(solar);

    return {
      hydro,
      thermal,
      solar,
      totals: {
        hydro: hydroTotal,
        thermal: thermalTotal,
        solar: solarTotal,
        total: hydroTotal + thermalTotal + solarTotal,
      },
    };
  }, [data, languageType]);

  return {
    ...processed,
    isLoading,
  };
};
